<script lang="ts" setup>
import { useCityStore } from '@/store/city/city'

const DEFAULT_ARCHIVE_SALE = 'Акция завершена'

type Props = {
  archive: boolean
  image: string
  title?: string
  linkSale: string
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
})

const {
  cityInfo: { padeg },
} = useCityStore()

const saleImageAlt = `Акция «${props.title}» в ${padeg?.pred}`

const saleImageTitle = `Акция «${props.title}» от ресторана Farfor в ${padeg?.pred}`

const isSaleImageCrashed = ref(false)

const prefixLink = props.archive ? '/sales/archive' : '/sales'

const saleImage =
  !isSaleImageCrashed.value || props?.image
    ? props?.image
    : './no-image-sale.webp'
</script>

<template>
  <div>
    <nuxt-link
      :to="`${prefixLink}/${linkSale}/`"
      class="sale__top"
      :prefetch="false"
    >
      <nuxt-img
        class="sale__top-image"
        :class="{ 'archive--image': archive }"
        :src="saleImage"
        :alt="saleImageAlt"
        :title="saleImageTitle"
        loading="lazy"
        format="webp"
        quality="80"
        width="100%"
        height="100%"
        @error="isSaleImageCrashed = true"
      />

      <the-status
        v-if="archive"
        :text="DEFAULT_ARCHIVE_SALE"
        class="sale__top-archive"
        bg-color="var(--ui-secondary)"
      />

      <span class="sale__top-headline">
        {{ title }}
      </span>
    </nuxt-link>
  </div>
</template>

<style lang="scss" scoped>
.sale__top {
  height: max-content;
  color: var(--ui-text-primary);
  cursor: pointer;

  &-image {
    width: 100%;
    height: 147px;
    margin-bottom: 25px;
    border-radius: 20px;

    @include media('>desktop-mini') {
      max-height: 147px;
      object-fit: cover;
    }
  }
  .archive--image {
    opacity: 0.5;
  }

  &-archive {
    margin-bottom: 20px;
  }

  &-headline {
    display: block;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 800;
    line-height: 19px;
  }
}
</style>
